import classNames from 'classnames';
import Image from '../image/Image';
import combineModifiers from '../../../../../utils/modifiers/combineModifiers';

export default function Images({ className, modifier, images }) {
  return (
    <div
      className={classNames(
        'universal-modal__images',
        className,
        ...combineModifiers('universal-modal__images', modifier),
      )}
    >
      {images?.map((image, index) => (
        <Image key={index} className={'universal-modal__image'} img={image} type={'few'} />
      ))}
    </div>
  );
}
